"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var Ng2UtilsDirective = (function () {
    function Ng2UtilsDirective() {
    }
    return Ng2UtilsDirective;
}()); // dummy directive to allow non-standard tags
Ng2UtilsDirective = __decorate([
    core_1.Directive({
        selector: 'ng2-utils-1, ng2-utils-2, ng2-utils-3, ng2-utils-4, ng2-utils-5,' +
            'ng2-utils-6, ng2-utils-7, ng2-utils-8, ng2-utils-9, ng2-utils-10,' +
            'ng2-utils-11, ng2-utils-12, ng2-utils-13, ng2-utils-14, ng2-utils-15,' +
            'ng2-utils-16, ng2-utils-17, ng2-utils-18, ng2-utils-19, ng2-utils-20'
    }),
    __metadata("design:paramtypes", [])
], Ng2UtilsDirective);
exports.Ng2UtilsDirective = Ng2UtilsDirective;
//# sourceMappingURL=ng2-utils.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-utils/dist/directives/ng2-utils.directive.js
// module id = 697
// module chunks = 0